<template>
  <b-form-group>
    <label>{{ label }}</label>
    <multiselect
      class="mt-2"
      v-model="nocJobTitle"
      label="title_fr"
      track-by="id"
      placeholder="Choose a NOC Job title"
      open-direction="bottom"
      :options="nocJobTitles"
      :searchable="true"
      :loading="isLoading"
      :internal-search="false"
      :clear-on-select="false"
      :close-on-select="true"
      :options-limit="300"
      :max-height="600"
      :show-no-results="false"
      :hide-selected="true"
      @search-change="debounceSearch"
      @input="handleInput"
      preserveSearch
      :disabled="disabled"
    ></multiselect>
  </b-form-group>
</template>

<script>
import { BFormGroup } from "bootstrap-vue";
import Multiselect from "vue-multiselect";
export default {
  components: { BFormGroup, Multiselect },
  props: {
    value: {
      type: Object,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: "NOC Job Title"
    }
  },
  data() {
    return {
      timeout: null,
      isLoading: false,
      nocJobTitle: this.value,
      nocJobTitles: []
    };
  },
  destroyed() {
    clearInterval(this.timeout);
  },
  methods: {
    debounceSearch(query) {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.fetchNocJobTitleData(query);
      }, 450);
    },
    async fetchNocJobTitleData(query) {
      this.isLoading = true;
      await this.$http
        .get("/noc-job-titles", {
          params: {
            title: query,
            page: 1,
            lang: "fr"
          }
        })
        .then(({ data }) => {
          this.nocJobTitles = data.data;
        })
        .finally(() => (this.isLoading = false));
    },
    handleInput() {
      this.$emit("input", this.nocJobTitle);
    }
  }
};
</script>
